import React from "react";
import "./TransportPage.css";

const data = [
  {
    vehicle: "SWIFT DESIRE A/C CAB BSVI 2024",
    local: [
      "12 HOURS 100 KM @ 3500/-",
      "EXTRA HOURS @ 150/-",
      "EXTRA KM @ 13/-",
    ],
    outstation: [
      "PER KM @ 13/-",
      "PER DAY MINIMUM 300 KM AS PER CALENDAR DATE",
      "PER DAY DRIVER BHATA 500/- AS PER CALENDAR DATE",
    ],
  },
  {
    vehicle: "ERTIGA A/C CAB 7 SEATER BSVI 2025",
    local: [
      "12 HOURS 100 KM @ 4000/-",
      "EXTRA HOURS @ 200/-",
      "EXTRA KM @ 17/-",
    ],
    outstation: [
      "PER KM @ 17/-",
      "PER DAY MINIMUM 300 KM AS PER CALENDAR DATE",
      "PER DAY DRIVER BHATA 500/- AS PER CALENDAR DATE",
    ],
  },
  {
    vehicle: "INNOVA A/C CAB 8 SEATER BSIV 2016",
    local: [
      "12 HOURS 100 KM @ 4000/-",
      "EXTRA HOURS @ 200/-",
      "EXTRA KM @ 18/-",
    ],
    outstation: [
      "PER KM @ 18/-",
      "PER DAY MINIMUM 300 KM AS PER CALENDAR DATE",
      "PER DAY DRIVER BHATA 500/- AS PER CALENDAR DATE",
    ],
  },
  {
    vehicle: "CRYSTA A/C CAB 8 SEATER BSVI 2024",
    local: [
      "12 HOURS 100 KM @ 4500/-",
      "EXTRA HOURS @ 250/-",
      "EXTRA KM @ 20/-",
    ],
    outstation: [
      "PER KM @ 20/-",
      "PER DAY MINIMUM 300 KM AS PER CALENDAR DATE",
      "PER DAY DRIVER BHATA 500/-",
    ],
  },
  {
    vehicle: "HYCROSS A/C CAB 8 SEATER BSVI 2026",
    local: [
      "12 HOURS 100 KM @ 5500/-",
      "EXTRA HOURS @ 300/-",
      "EXTRA KM @ 23/-",
    ],
    outstation: [
      "PER KM @ 23/-",
      "PER DAY MINIMUM 300 KM AS PER CALENDAR DATE",
      "PER DAY DRIVER BHATA 500/-",
    ],
  }
];

const TransportPage = () => {
  return (
    <div className="page">

      <div className="header">
        <h1>HYDERABAD TOURS AND TRAVEL™</h1>
        <h2>100% PURE B2B RATES SHEET</h2>
        <div className="subHeader">
          <p>HYDERABAD LOCAL TWIN CITY TOUR & RAMOJI FILM CITY TOUR RATE SHEET</p>
          <p>OUT OF STATION RATE SHEET</p>
        </div>
      </div>

      <div className="tableWrapper">
        <table className="table">
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Local</th>
              <th>Outstation</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="vehicle">{item.vehicle}</td>
                <td>
                  {item.local.map((l, i) => (
                    <p key={i}>{l}</p>
                  ))}
                </td>
                <td>
                  {item.outstation.map((o, i) => (
                    <p key={i}>{o}</p>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="notes">
        <p>NOTE: TOLL GATE PARKING INCLUDING AS PER ABOVE RATES</p>
        <p>NOTE: BEFORE 6:00 AM AFTER 11:00 PM DRIVER BATA @ 200/-</p>
        <p>NOTE: AFTER 00:00 HRS. CAB CONTINUE AND WILL BE CALCULATED PER ANOTHER SLAB</p>
        <p>NOTE: VEHICLE TIME & RIDING STARTING AND CLOSING WILL BE GARAGE TO GARAGE</p>
        <p>NOTE: 5% GST WILL BE CHARGED AS PER THE GOVT. RULES ON GROSS BILLING AMOUNT</p>

        <p>NOTE: TOLL GATE PARKING STATE TAX EXTRA AS PER</p>
        <p>NOTE: BEFORE 6:00 AM AFTER 10:00 PM DRIVER BATA @ 200/-</p>
        <p>NOTE: AFTER 00:00 HRS. CAB CONTINUE AND WILL BE CALCULATED PER ANOTHER SLAB</p>
        <p>NOTE: VEHICLE TIME & RIDING STARTING AND CLOSING WILL BE GARAGE TO GARAGE</p>
        <p>NOTE: 5% WILL BE CHARGED AS PER THE GOVT. RULES ON GROSS BILLING AMOUNT</p>
      </div>

<div className="finalSection">

  {/* Highlight Notice */}
  <div className="highlightBox">
    <p>
      PLEASE NOTE - Irrespective Of The Above-Mentioned Cancellation Slabs,
      Minimum 10% Service Charges Applicable.
    </p>
  </div>

  {/* Refund Box */}
  <div className="refundBox">
    <h3>Refund Policy</h3>
    <p>
      Refund Depends On Recovery From Hotels. Unused Services Like Hotel,
      Transport, Meals Are Non-Refundable.
    </p>
  </div>

  {/* Agreement */}
  <div className="agreementBox">
    <p>
      If acceptable, sign and return agreement copy. Valid till 31.03.2027.
    </p>
  </div>

  {/* Company Card */}
  <div className="companyCard">
    <h2>HYDERABAD TOURS AND TRAVELS™</h2>

    <p className="address">
      # 5 - 9 - 101/D, Assembly Metro Station, Opp. Public Gardens,
      Nampally, Hyderabad - 500001
    </p>

    <div className="signature">
      <p><b>Maruthi Mhetre</b></p>
      <span>Founder Chairman & Managing Director</span>
      <p className="date">01/03/2026</p>
    </div>
  </div>

  {/* Contacts */}
  <div className="contactGrid">

    <div className="contactCard">
      <h4>GIT & MICE</h4>
      <p>Mr Maruthi</p>
      <p>9701238500</p>
      <p>8008433898</p>
    </div>

    <div className="contactCard">
      <h4>FIT & GIT</h4>
      <p>Mrs Malashree</p>
      <p>9000308958</p>
      <p>9666000030</p>
    </div>

    <div className="contactCard">
      <h4>Transport</h4>
      <p>Ms Swapna</p>
      <p>9133100093</p>
      <p>9133100094</p>
    </div>

    <div className="contactCard">
      <h4>Executive</h4>
      <p>Mr Sandeep</p>
      <p>9133100091</p>
    </div>

    <div className="contactCard">
      <h4>Holiday Packages</h4>
      <p>Ms Sangita</p>
      <p>9133100092</p>
    </div>

  </div>

  {/* Footer */}
  <div className="footerBox">
    <div>
      <p><b>PAN:</b> BIJPM2951C</p>
      <p><b>GST:</b> 36BIJPM2951C1ZD</p>
    </div>

    <div className="emails">
      <p>sales@hyderabadtoursandtravels.com</p>
      <p>dmc@hyderabadtoursandtravels.com</p>
      <p>b2b@hyderabadtoursandtravels.com</p>
      <p>booking@hyderabadtoursandtravels.com</p>
    </div>

    <p className="website">
      www.hyderabadtoursandtravels.com
    </p>
  </div>

</div>

    </div>
  );
};

export default TransportPage;
